import React from 'react';

import Help from '../components/DropdownHelp';
import UserMenu from '../components/DropdownProfile';
import ThemeToggle from '../components/ThemeToggle';
import config from '@/config';
import { useSelector } from 'react-redux';

function Header({
  sidebarOpen,
  setSidebarOpen,
  dropdownOpen,
  setDropdownOpen,
  impersonationModalOpen,
  setImpersonationModalOpen,
}) {
  const { isDemoUser } = useSelector((state) => state.app);
  return (
    <header className="sticky top-0 bg-white dark:bg-theme-surface-accent border-b border-slate-200 dark:border-slate-700 z-30">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 -mb-px">
          {/* Header: Left side */}
          <div className="flex gap-2">

            {/* Hamburger button */}
            <button
              className="text-slate-500 hover:text-slate-600 lg:hidden __tutorial-hamburger-button"
              aria-controls="sidebar"
              aria-expanded={sidebarOpen}
              onClick={(e) => { e.stopPropagation(); setSidebarOpen(!sidebarOpen); }}
            >
              <span className="sr-only">Open sidebar</span>
              <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="2" />
                <rect x="4" y="11" width="16" height="2" />
                <rect x="4" y="17" width="16" height="2" />
              </svg>
            </button>
            {config.environment !== "production" && !isDemoUser && <span className="text-lg font-bold text-red-500">{config.environment}</span>}
            {isDemoUser && <span className="text-lg font-bold text-red-500">Demo</span>}
          </div>

          {/* Header: Right side */}
          <div className="flex items-center space-x-3">
            <Help align="right" />
            <ThemeToggle />
            {/*  Divider */}
            <hr className="w-px h-6 bg-slate-200 dark:bg-slate-700 border-none" />
            <UserMenu 
              
              align="right" 
              impersonationModalOpen={impersonationModalOpen}
              setImpersonationModalOpen={setImpersonationModalOpen}
              dropdownOpen={dropdownOpen}
              setDropdownOpen={setDropdownOpen}
            />

          </div>

        </div>
      </div>
    </header>
  );
}

export default Header;